import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";

import { Badge, DefaultTable } from 'twyne-new.ui';

import { Card } from "@/components/reports/card";

import { STATUS_MAPPER } from "../utils";

function StepCardHeader({ step }) {
  const { activities, offersRequired } = step

  const completedActivities = activities?.filter(activity => activity.status === 'completed');
  const isCompleted = completedActivities?.length === offersRequired;

  return <div className="flex justify-between items-center">
    <Link to={`/cms/rewards/${step.rewardId}/steps/${step.id}`} className="twy-text-accent text-md">
      {`[STEP][#${step.id}] - ${step.name}`}
    </Link>
    {isCompleted ? <Badge color="success" variant='outline'>Completed</Badge> : <Badge color="accent" variant='outline'>In progress</Badge>
    }
  </div>
}

export default function Step({ step }) {
  const columns = [{
    dataField: 'id',
    text: 'Activity Id',
  }, {
    dataField: 'externalActivityId',
    text: 'External Activity Id',
  }, {
    dataField: 'externalActivityName',
    text: 'External Activity Name',
  }, {
    dataField: 'payout',
    text: 'Payout',
    formatter: col => <NumberFormat
      value={col}
      displayType="text"
      thousandSeparator=","
      decimalSeparator="."
      prefix="$"
      decimalScale={2}
      fixedDecimalScale
    />,
  }, {
    dataField: 'status',
    text: 'Status',
    formatter: col => <Badge color={STATUS_MAPPER[col]} variant='light'>{col}</Badge>,
  }]

  return <Card sectionClass='w-full' title={<StepCardHeader step={step} />}>
    <DefaultTable
      data={step.activities}
      columns={columns}
      noDataIndication={() => 'No content to show.'}
    />
  </Card>
}
